var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiGetOneRelease } from '@/actions/ReleaseActions';
import { notifyError } from '@/helpers/action';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { SESSION_STORAGE_KEY_RELEASE_ONE } from '@/utils/constants/storage/sessionStorageKey';
import { useSessionStorage } from '@/utils/libs/react-hookz/useSessionStorage';
/**
 * ニュース詳細のデータを取得するカスタムフック
 * @param options
 * @returns
 */
export const useReleaseOneFetch = (options) => {
    const { dispatch, unmountRef } = options;
    // ニュース詳細 データを保存
    const { set: setReleaseOneData, value: releaseOneData } = useSessionStorage(SESSION_STORAGE_KEY_RELEASE_ONE, {
        defaultValue: {},
    });
    /**
     * ニュース詳細のデータを取得
     */
    const fetchReleaseOneBase = useCallback((id) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { payload } = yield wrapDispatch(dispatch, apiGetOneRelease({ path: { id } }, {}));
            // 取得したデータを sessionStorage に保存
            if (!unmountRef.current) {
                setReleaseOneData((prev) => (Object.assign(Object.assign({}, prev), { [payload.id]: payload })));
            }
        }
        catch (error) {
            // エラー時は、エラーメッセージを表示
            if (!unmountRef.current) {
                notifyError();
            }
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }), [dispatch, setReleaseOneData, unmountRef]);
    // ローディング状態を管理
    const { callbackPromiseEvent: fetchReleaseOne, doing: loading } = usePromiseDoingCallback({
        initialDoingState: true,
        promiseEvent: fetchReleaseOneBase,
        unmountRef,
    });
    return {
        fetchReleaseOne,
        loading,
        releaseOneData,
    };
};
